import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from "../../lib";

import {
  doREQUEST_ERROR,
  doREQUEST_COMPLETE,
  doPROJECT_STATUS_UPDATE,
  doBATCH_RESET_PARTICIPANT,
} from "../state";
import { getToken } from "./token_fetcher";

export const REQUEST_PROJECT_RESET = "REQUEST_PROJECT_RESET";
export const doREQUEST_PROJECT_RESET = createDoRequestAction(REQUEST_PROJECT_RESET);

export const requestProjectResetActionCreators = {
  doREQUEST_PROJECT_RESET,
};

export function* requestProjectReset({ payload, setRequestResult }: any): SagaIterator {
  debug("saga*requestProject");

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        projectId: v.string().uuid().exist(),
        batchId: v.string().uuid().exist(),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_RESET,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const { projectId, batchId } = payload;

  const accessToken = yield call(getToken);

  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/project-reset`,
    accessToken,
    data: {
      projectId,
    },
  });

  // handle error
  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_RESET,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/project-reset",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(doPROJECT_STATUS_UPDATE({ id: projectId }));

  yield put(doBATCH_RESET_PARTICIPANT({ id: batchId }));

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PROJECT_RESET,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* projectResetSaga() {
  yield takeEvery(REQUEST_PROJECT_RESET, requestProjectReset);
}
